import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent implements OnInit, OnChanges {
  @Input() searchString: string;
  @Input() label: string;

  get searchQuery() {
    return this.form.get('searchQuery');
  }

  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.form = this.fb.group({
      searchQuery: [this.searchString, [Validators.minLength(3)]],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.searchString.previousValue) {
      this.searchQuery.setValue(changes.searchString.currentValue);
    }
  }

  onSubmit() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        q: this.searchQuery && this.searchQuery.value != '' ? this.searchQuery.value : null,
      },
      queryParamsHandling: 'merge',
    });
  }

  resetSearchQuery() {
    this.searchQuery.setValue('');
    this.onSubmit();
  }
}
